//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpStepperFormSection',
  props: {
    title: { type: String, default: '' },
    success: { type: Boolean, default: false }, // just has to evaluate truth-y
  },
  computed: {
    sectionNumber() {
      const form = this.$parent;
      if (!form || form.$options.name !== 'DpStepperForm') {
        return null;
      }

      let curr = 0;
      for (let j = 0; j < form.$children.length; j += 1) {
        const c = form.$children[j];
        if (c.$options.name === 'DpStepperFormSection') {
          curr += 1;
        }

        if (c.$el === this.$el) {
          return curr;
        }
      }
      return null;
    },
  },
};
